import { FC } from 'react';
import { Tooltip } from 'react-tooltip';

type TooltipPlace = 'top' | 'bottom' | 'left' | 'right';

type IconInfoProps = {
  id: string;
  icon?: string;
  className?: string;
  wrapperClassName?: string;
  tooltip?: string;
  place?: TooltipPlace;
};

const DEFAULT_ICON = 'info';
const DEFAULT_PLACE = 'top';

const IconTooltip: FC<IconInfoProps> = ({
  className = '',
  icon = DEFAULT_ICON,
  id,
  place = DEFAULT_PLACE,
  tooltip,
  wrapperClassName = '',
}) => {
  const isDisabled = !tooltip;
  const iconClass = `icon ni ni-${icon} ml-1 ${className} ${
    isDisabled ? 'cursor-default text-soft' : 'cursor-help'
  }`;
  const tooltipClass = 'w-max-300px z-1000';

  return (
    <div className={wrapperClassName}>
      <em className={iconClass} data-tooltip-id={isDisabled ? undefined : id} />

      {tooltip && (
        <Tooltip
          id={id}
          className={tooltipClass}
          place={place}
          style={{
            zIndex: 9999,
          }}
        >
          {tooltip}
        </Tooltip>
      )}
    </div>
  );
};

export default IconTooltip;
